// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/** Auto-generated argument types based on "en" i18n strings. Do not edit manually. */
export interface I18nFormatArgTypes {
  '[charts]': {
    loadingText: never;
    errorText: never;
    recoveryText: never;
    'i18nStrings.filterLabel': never;
    'i18nStrings.filterPlaceholder': never;
    'i18nStrings.legendAriaLabel': never;
    'i18nStrings.chartAriaRoleDescription': never;
    'i18nStrings.xAxisAriaRoleDescription': never;
    'i18nStrings.yAxisAriaRoleDescription': never;
  };
  alert: {
    dismissAriaLabel: never;
    'i18nStrings.successIconAriaLabel': never;
    'i18nStrings.errorIconAriaLabel': never;
    'i18nStrings.warningIconAriaLabel': never;
    'i18nStrings.infoIconAriaLabel': never;
    'i18nStrings.dismissAriaLabel': never;
  };
  'annotation-context': {
    'i18nStrings.nextButtonText': never;
    'i18nStrings.previousButtonText': never;
    'i18nStrings.finishButtonText': never;
    'i18nStrings.labelDismissAnnotation': never;
    'i18nStrings.stepCounterText': {
      stepNumber: string | number;
      totalStepCount: string | number;
    };
    'i18nStrings.taskTitle': {
      taskNumber: string | number;
      taskTitle: string | number;
    };
    'i18nStrings.labelHotspot': {
      openState: string;
      stepNumber: string | number;
      totalStepCount: string | number;
    };
  };
  'app-layout': {
    'ariaLabels.drawers': never;
    'ariaLabels.drawersOverflow': never;
    'ariaLabels.drawersOverflowWithBadge': never;
    'ariaLabels.navigation': never;
    'ariaLabels.navigationClose': never;
    'ariaLabels.navigationToggle': never;
    'ariaLabels.notifications': never;
    'ariaLabels.tools': never;
    'ariaLabels.toolsClose': never;
    'ariaLabels.toolsToggle': never;
  };
  'area-chart': {
    'i18nStrings.detailTotalLabel': never;
  };
  'attribute-editor': {
    removeButtonText: never;
    'i18nStrings.itemRemovedAriaLive': never;
  };
  autosuggest: {
    errorIconAriaLabel: never;
    selectedAriaLabel: never;
    enteredTextLabel: {
      value: string | number;
    };
    recoveryText: never;
  };
  'breadcrumb-group': {
    expandAriaLabel: never;
  };
  button: {
    'i18nStrings.externalIconAriaLabel': never;
  };
  calendar: {
    nextMonthAriaLabel: never;
    previousMonthAriaLabel: never;
    todayAriaLabel: never;
    'i18nStrings.nextYearAriaLabel': never;
    'i18nStrings.previousYearAriaLabel': never;
    'i18nStrings.currentMonthAriaLabel': never;
  };
  cards: {
    'ariaLabels.selectionGroupLabel': never;
  };
  'code-editor': {
    'i18nStrings.loadingState': never;
    'i18nStrings.errorState': never;
    'i18nStrings.errorStateRecovery': never;
    'i18nStrings.editorGroupAriaLabel': never;
    'i18nStrings.statusBarGroupAriaLabel': never;
    'i18nStrings.cursorPosition': {
      row: string | number;
      column: string | number;
    };
    'i18nStrings.errorsTab': never;
    'i18nStrings.warningsTab': never;
    'i18nStrings.preferencesButtonAriaLabel': never;
    'i18nStrings.paneCloseButtonAriaLabel': never;
    'i18nStrings.preferencesModalHeader': never;
    'i18nStrings.preferencesModalCancel': never;
    'i18nStrings.preferencesModalConfirm': never;
    'i18nStrings.preferencesModalWrapLines': never;
    'i18nStrings.preferencesModalTheme': never;
    'i18nStrings.preferencesModalThemeFilteringAriaLabel': never;
    'i18nStrings.preferencesModalThemeFilteringPlaceholder': never;
    'i18nStrings.preferencesModalLightThemes': never;
    'i18nStrings.preferencesModalDarkThemes': never;
    'i18nStrings.cursorPositionAriaLabel': {
      row: string | number;
    };
    'i18nStrings.resizeHandleAriaLabel': never;
    'i18nStrings.resizeHandleTooltipText': never;
  };
  'collection-preferences': {
    title: never;
    confirmLabel: never;
    cancelLabel: never;
    'pageSizePreference.title': never;
    'wrapLinesPreference.label': never;
    'wrapLinesPreference.description': never;
    'stripedRowsPreference.label': never;
    'stripedRowsPreference.description': never;
    'contentDensityPreference.label': never;
    'contentDensityPreference.description': never;
    'stickyColumnsPreference.firstColumns.title': never;
    'stickyColumnsPreference.firstColumns.description': never;
    'stickyColumnsPreference.firstColumns.options[0].label': never;
    'stickyColumnsPreference.firstColumns.options[1].label': never;
    'stickyColumnsPreference.firstColumns.options[2].label': never;
    'stickyColumnsPreference.lastColumns.title': never;
    'stickyColumnsPreference.lastColumns.description': never;
    'stickyColumnsPreference.lastColumns.options[0].label': never;
    'stickyColumnsPreference.lastColumns.options[1].label': never;
    'contentDisplayPreference.title': never;
    'contentDisplayPreference.description': never;
    'contentDisplayPreference.dragHandleAriaLabel': never;
    'contentDisplayPreference.dragHandleAriaDescription': never;
    'contentDisplayPreference.liveAnnouncementDndStarted': {
      position: string | number;
      total: string | number;
    };
    'contentDisplayPreference.liveAnnouncementDndDiscarded': never;
    'contentDisplayPreference.i18nStrings.columnFilteringPlaceholder': never;
    'contentDisplayPreference.i18nStrings.columnFilteringAriaLabel': never;
    'contentDisplayPreference.i18nStrings.columnFilteringNoMatchText': never;
    'contentDisplayPreference.i18nStrings.columnFilteringClearFilterText': never;
    'contentDisplayPreference.liveAnnouncementDndItemReordered': {
      isInitialPosition: string;
      currentPosition: string | number;
      total: string | number;
    };
    'contentDisplayPreference.liveAnnouncementDndItemCommitted': {
      isInitialPosition: string;
      initialPosition: string | number;
      total: string | number;
      finalPosition: string | number;
    };
    'contentDisplayPreference.i18nStrings.columnFilteringCountText': {
      count: number;
    };
  };
  'copy-to-clipboard': {
    'i18nStrings.copyButtonText': never;
  };
  'date-picker': {
    'i18nStrings.openCalendarAriaLabel': {
      selectedDate: string;
    };
  };
  'date-range-picker': {
    'i18nStrings.relativeModeTitle': never;
    'i18nStrings.absoluteModeTitle': never;
    'i18nStrings.relativeRangeSelectionHeading': never;
    'i18nStrings.relativeRangeSelectionMonthlyDescription': never;
    'i18nStrings.cancelButtonLabel': never;
    'i18nStrings.clearButtonLabel': never;
    'i18nStrings.applyButtonLabel': never;
    'i18nStrings.customRelativeRangeOptionLabel': never;
    'i18nStrings.customRelativeRangeOptionDescription': never;
    'i18nStrings.customRelativeRangeUnitLabel': never;
    'i18nStrings.customRelativeRangeDurationLabel': never;
    'i18nStrings.customRelativeRangeDurationPlaceholder': never;
    'i18nStrings.previousMonthAriaLabel': never;
    'i18nStrings.nextMonthAriaLabel': never;
    'i18nStrings.previousYearAriaLabel': never;
    'i18nStrings.nextYearAriaLabel': never;
    'i18nStrings.currentMonthAriaLabel': never;
    'i18nStrings.todayAriaLabel': never;
    'i18nStrings.startMonthLabel': never;
    'i18nStrings.startDateLabel': never;
    'i18nStrings.startTimeLabel': never;
    'i18nStrings.endMonthLabel': never;
    'i18nStrings.endDateLabel': never;
    'i18nStrings.endTimeLabel': never;
    'i18nStrings.isoDatePlaceholder': never;
    'i18nStrings.slashedDatePlaceholder': never;
    'i18nStrings.timePlaceholder': never;
    'i18nStrings.dateTimeConstraintText': never;
    'i18nStrings.dateConstraintText': never;
    'i18nStrings.slashedDateTimeConstraintText': never;
    'i18nStrings.isoDateTimeConstraintText': never;
    'i18nStrings.slashedDateConstraintText': never;
    'i18nStrings.isoDateConstraintText': never;
    'i18nStrings.slashedMonthConstraintText': never;
    'i18nStrings.isoMonthConstraintText': never;
    'i18nStrings.monthConstraintText': never;
    'i18nStrings.errorIconAriaLabel': never;
    'i18nStrings.renderSelectedAbsoluteRangeAriaLive': {
      startDate: string | number;
      endDate: string | number;
    };
    'i18nStrings.formatRelativeRange': {
      unit: string;
      amount: number;
    };
    'i18nStrings.formatUnit': {
      unit: string;
      amount: number;
    };
  };
  drawer: {
    'i18nStrings.loadingText': never;
  };
  'error-boundary': {
    'i18nStrings.headerText'?: never;
    'i18nStrings.descriptionText'?: {
      hasFeedback: boolean;
      Feedback: (chunks: React.ReactNode[]) => React.ReactNode;
    };
    'i18nStrings.refreshActionText'?: never;
  };
  'features-notification-drawer': {
    'i18nStrings.title': never;
    'i18nStrings.viewAll': never;
    'ariaLabels.closeButton': never;
    'ariaLabels.content': never;
    'ariaLabels.triggerButton': never;
    'ariaLabels.resizeHandle': never;
  };
  'file-token-group': {
    'i18nStrings.limitShowFewer': never;
    'i18nStrings.limitShowMore': never;
    'i18nStrings.removeFileAriaLabel': {
      fileIndex: string | number;
      fileName: string;
    };
    'i18nStrings.errorIconAriaLabel': never;
    'i18nStrings.warningIconAriaLabel': never;
  };
  'file-upload': {
    'i18nStrings.limitShowFewer': never;
    'i18nStrings.limitShowMore': never;
    'i18nStrings.removeFileAriaLabel': {
      fileIndex: string | number;
      fileName: string;
    };
    'i18nStrings.errorIconAriaLabel': never;
    'i18nStrings.warningIconAriaLabel': never;
    'i18nStrings.uploadButtonText': {
      multiple: string;
    };
    'i18nStrings.dropzoneText': {
      multiple: string;
    };
  };
  flashbar: {
    'i18nStrings.ariaLabel': never;
    'i18nStrings.errorIconAriaLabel': never;
    'i18nStrings.inProgressIconAriaLabel': never;
    'i18nStrings.infoIconAriaLabel': never;
    'i18nStrings.notificationBarAriaLabel': never;
    'i18nStrings.notificationBarText': never;
    'i18nStrings.successIconAriaLabel': never;
    'i18nStrings.warningIconAriaLabel': never;
  };
  'form-field': {
    'i18nStrings.errorIconAriaLabel': never;
    'i18nStrings.warningIconAriaLabel': never;
  };
  form: {
    errorIconAriaLabel: never;
  };
  'help-panel': {
    loadingText: never;
  };
  input: {
    clearAriaLabel: never;
  };
  link: {
    externalIconAriaLabel: never;
  };
  list: {
    dragHandleAriaLabel: never;
    dragHandleAriaDescription: never;
    liveAnnouncementDndStarted: {
      position: string | number;
      total: string | number;
    };
    liveAnnouncementDndDiscarded: never;
    liveAnnouncementDndItemReordered: {
      isInitialPosition: string;
      currentPosition: string | number;
      total: string | number;
    };
    liveAnnouncementDndItemCommitted: {
      isInitialPosition: string;
      initialPosition: string | number;
      total: string | number;
      finalPosition: string | number;
    };
  };
  modal: {
    closeAriaLabel: never;
  };
  multiselect: {
    deselectAriaLabel: {
      option__label: string | number;
    };
    'i18nStrings.selectAllText': never;
  };
  pagination: {
    'ariaLabels.nextPageLabel': never;
    'ariaLabels.pageLabel': {
      pageNumber: string | number;
    };
    'ariaLabels.previousPageLabel': never;
    'ariaLabels.jumpToPageButtonLabel': never;
    'i18nStrings.jumpToPageInputLabel': never;
    'i18nStrings.jumpToPageError': never;
    'i18nStrings.jumpToPageLoadingText': never;
  };
  'panel-resize-handle': {
    'i18nStrings.resizeHandleAriaLabel': never;
    'i18nStrings.resizeHandleTooltipText': never;
  };
  'pie-chart': {
    'i18nStrings.detailsValue': never;
    'i18nStrings.detailsPercentage': never;
    'i18nStrings.chartAriaRoleDescription': never;
    'i18nStrings.segmentAriaRoleDescription': never;
  };
  popover: {
    dismissAriaLabel: never;
  };
  'prompt-input': {
    'i18nStrings.actionButtonAriaLabel': never;
    'i18nStrings.menuErrorIconAriaLabel': never;
    'i18nStrings.menuRecoveryText': never;
    'i18nStrings.menuLoadingText': never;
    'i18nStrings.menuFinishedText': never;
    'i18nStrings.menuErrorText': never;
    'i18nStrings.selectedMenuItemAriaLabel': never;
    'i18nStrings.tokenInsertedAriaLabel': {
      token__label: string;
    };
    'i18nStrings.tokenPinnedAriaLabel': {
      token__label: string;
    };
    'i18nStrings.tokenRemovedAriaLabel': {
      token__label: string;
    };
  };
  'property-filter': {
    'i18nStrings.allPropertiesLabel': never;
    'i18nStrings.applyActionText': never;
    'i18nStrings.cancelActionText': never;
    'i18nStrings.clearFiltersText': never;
    'i18nStrings.editTokenHeader': never;
    'i18nStrings.groupPropertiesText': never;
    'i18nStrings.groupValuesText': never;
    'i18nStrings.operationAndText': never;
    'i18nStrings.operationOrText': never;
    'i18nStrings.operatorContainsText': never;
    'i18nStrings.operatorDoesNotContainText': never;
    'i18nStrings.operatorDoesNotEqualText': never;
    'i18nStrings.operatorEqualsText': never;
    'i18nStrings.operatorGreaterOrEqualText': never;
    'i18nStrings.operatorGreaterText': never;
    'i18nStrings.operatorLessOrEqualText': never;
    'i18nStrings.operatorLessText': never;
    'i18nStrings.operatorStartsWithText': never;
    'i18nStrings.operatorDoesNotStartWithText': never;
    'i18nStrings.operatorText': never;
    'i18nStrings.operatorsText': never;
    'i18nStrings.propertyText': never;
    'i18nStrings.removeTokenButtonAriaLabel': {
      token__formattedText: string | number;
    };
    'i18nStrings.tokenEditorTokenActionsAriaLabel': {
      token__formattedText: string | number;
    };
    'i18nStrings.tokenEditorTokenRemoveAriaLabel': {
      token__formattedText: string | number;
    };
    'i18nStrings.tokenEditorTokenRemoveLabel': never;
    'i18nStrings.tokenEditorTokenRemoveFromGroupLabel': never;
    'i18nStrings.tokenEditorAddTokenActionsAriaLabel': never;
    'i18nStrings.tokenEditorAddNewTokenLabel': never;
    'i18nStrings.tokenEditorAddExistingTokenAriaLabel': {
      token__formattedText: string | number;
    };
    'i18nStrings.tokenEditorAddExistingTokenLabel': {
      token__propertyLabel: string | number;
      token__operator: string | number;
      token__value: string | number;
    };
    'i18nStrings.tokenLimitShowFewer': never;
    'i18nStrings.tokenLimitShowMore': never;
    'i18nStrings.valueText': never;
    'i18nStrings.formatToken': {
      token__operator: string;
      token__propertyLabel: string | number;
      token__value: string | number;
    };
    'i18nStrings.groupEditAriaLabel': {
      group__formattedTokens__length: string;
      group__formattedTokens0__formattedText: string | number;
      group__operationLabel: string | number;
      group__formattedTokens1__formattedText: string | number;
      group__formattedTokens2__formattedText: string | number;
      group__formattedTokens3__formattedText: string | number;
    };
  };
  's3-resource-selector': {
    'i18nStrings.inContextSelectPlaceholder': never;
    'i18nStrings.inContextBrowseButton': never;
    'i18nStrings.inContextViewButton': never;
    'i18nStrings.inContextViewButtonAriaLabel': never;
    'i18nStrings.inContextLoadingText': never;
    'i18nStrings.inContextUriLabel': never;
    'i18nStrings.inContextVersionSelectLabel': never;
    'i18nStrings.modalTitle': never;
    'i18nStrings.modalCancelButton': never;
    'i18nStrings.modalSubmitButton': never;
    'i18nStrings.modalBreadcrumbRootItem': never;
    'i18nStrings.modalLastUpdatedText': never;
    'i18nStrings.selectionBuckets': never;
    'i18nStrings.selectionObjects': never;
    'i18nStrings.selectionVersions': never;
    'i18nStrings.selectionBucketsSearchPlaceholder': never;
    'i18nStrings.selectionObjectsSearchPlaceholder': never;
    'i18nStrings.selectionVersionsSearchPlaceholder': never;
    'i18nStrings.selectionBucketsLoading': never;
    'i18nStrings.selectionBucketsNoItems': never;
    'i18nStrings.selectionObjectsLoading': never;
    'i18nStrings.selectionObjectsNoItems': never;
    'i18nStrings.selectionVersionsLoading': never;
    'i18nStrings.selectionVersionsNoItems': never;
    'i18nStrings.filteringNoMatches': never;
    'i18nStrings.filteringCantFindMatch': never;
    'i18nStrings.clearFilterButtonText': never;
    'i18nStrings.columnBucketID': never;
    'i18nStrings.columnBucketName': never;
    'i18nStrings.columnBucketCreationDate': never;
    'i18nStrings.columnBucketRegion': never;
    'i18nStrings.columnObjectKey': never;
    'i18nStrings.columnObjectLastModified': never;
    'i18nStrings.columnObjectSize': never;
    'i18nStrings.columnVersionID': never;
    'i18nStrings.columnVersionLastModified': never;
    'i18nStrings.columnVersionSize': never;
    'i18nStrings.validationPathMustBegin': never;
    'i18nStrings.validationBucketLowerCase': never;
    'i18nStrings.validationBucketMustNotContain': never;
    'i18nStrings.validationBucketLength': never;
    'i18nStrings.validationBucketMustComplyDns': never;
    'i18nStrings.labelSortedDescending': {
      columnName: string | number;
    };
    'i18nStrings.labelSortedAscending': {
      columnName: string | number;
    };
    'i18nStrings.labelNotSorted': {
      columnName: string | number;
    };
    'i18nStrings.labelsBucketsSelection.selectionGroupLabel': never;
    'i18nStrings.labelsBucketsSelection.itemSelectionLabel': {
      item__Name: string | number;
    };
    'i18nStrings.labelsObjectsSelection.selectionGroupLabel': never;
    'i18nStrings.labelsObjectsSelection.itemSelectionLabel': {
      item__Key: string | number;
    };
    'i18nStrings.labelsVersionsSelection.selectionGroupLabel': never;
    'i18nStrings.labelsVersionsSelection.itemSelectionLabel': {
      item__VersionId: string | number;
    };
    'i18nStrings.labelFiltering': {
      itemsType: string | number;
    };
    'i18nStrings.labelRefresh': never;
    'i18nStrings.labelBreadcrumbs': never;
    'i18nStrings.labelIconFolder': never;
    'i18nStrings.labelIconObject': never;
    'i18nStrings.filteringCounterText': {
      count: number;
    };
  };
  select: {
    errorIconAriaLabel: never;
    selectedAriaLabel: never;
    recoveryText: never;
  };
  slider: {
    'i18nStrings.valueTextRange': {
      value: string | number;
      previousValue: string | number;
      nextValue: string | number;
    };
  };
  'split-panel': {
    'i18nStrings.closeButtonAriaLabel': never;
    'i18nStrings.openButtonAriaLabel': never;
    'i18nStrings.preferencesTitle': never;
    'i18nStrings.preferencesPositionLabel': never;
    'i18nStrings.preferencesPositionDescription': never;
    'i18nStrings.preferencesPositionSide': never;
    'i18nStrings.preferencesPositionBottom': never;
    'i18nStrings.preferencesConfirm': never;
    'i18nStrings.preferencesCancel': never;
    'i18nStrings.resizeHandleAriaLabel': never;
    'i18nStrings.resizeHandleTooltipText': never;
  };
  table: {
    'ariaLabels.resizerRoleDescription': never;
    'ariaLabels.submittingEditText': never;
    'ariaLabels.successfulEditLabel': never;
    'ariaLabels.expandButtonLabel': never;
    'ariaLabels.collapseButtonLabel': never;
    'columnDefinitions.editConfig.errorIconAriaLabel': never;
    'columnDefinitions.editConfig.editIconAriaLabel': never;
  };
  tabs: {
    'i18nStrings.scrollLeftAriaLabel': never;
    'i18nStrings.scrollRightAriaLabel': never;
    'i18nStrings.tabsWithActionsAriaRoleDescription': never;
  };
  'tag-editor': {
    'i18nStrings.keyPlaceholder': never;
    'i18nStrings.valuePlaceholder': never;
    'i18nStrings.addButton': never;
    'i18nStrings.removeButton': never;
    'i18nStrings.removeButtonAriaLabel': {
      tag__key: string | number;
    };
    'i18nStrings.undoButton': never;
    'i18nStrings.undoPrompt': never;
    'i18nStrings.loading': never;
    'i18nStrings.keyHeader': never;
    'i18nStrings.valueHeader': never;
    'i18nStrings.optional': never;
    'i18nStrings.keySuggestion': never;
    'i18nStrings.valueSuggestion': never;
    'i18nStrings.emptyTags': never;
    'i18nStrings.tooManyKeysSuggestion': never;
    'i18nStrings.tooManyValuesSuggestion': never;
    'i18nStrings.keysSuggestionLoading': never;
    'i18nStrings.keysSuggestionError': never;
    'i18nStrings.valuesSuggestionLoading': never;
    'i18nStrings.valuesSuggestionError': never;
    'i18nStrings.emptyKeyError': never;
    'i18nStrings.maxKeyCharLengthError': never;
    'i18nStrings.maxValueCharLengthError': never;
    'i18nStrings.duplicateKeyError': never;
    'i18nStrings.invalidKeyError': never;
    'i18nStrings.invalidValueError': never;
    'i18nStrings.awsPrefixError': never;
    'i18nStrings.tagLimitReached': {
      tagLimit: number;
    };
    'i18nStrings.tagLimitExceeded': {
      tagLimit: number;
    };
    'i18nStrings.tagLimit': {
      tagLimitAvailable: string;
      availableTags: number;
      tagLimit: string | number;
    };
  };
  'token-group': {
    'i18nStrings.limitShowFewer': never;
    'i18nStrings.limitShowMore': never;
  };
  'top-navigation': {
    'i18nStrings.searchIconAriaLabel': never;
    'i18nStrings.searchDismissIconAriaLabel': never;
    'i18nStrings.overflowMenuTriggerText': never;
    'i18nStrings.overflowMenuDismissIconAriaLabel': never;
    'i18nStrings.overflowMenuBackIconAriaLabel': never;
    'i18nStrings.overflowMenuTitleText': never;
  };
  'tree-view': {
    'i18nStrings.expandButtonLabel': never;
    'i18nStrings.collapseButtonLabel': never;
  };
  'tutorial-panel': {
    'i18nStrings.loadingText': never;
    'i18nStrings.tutorialListTitle': never;
    'i18nStrings.tutorialListDownloadLinkText': never;
    'i18nStrings.labelTutorialListDownloadLink': never;
    'i18nStrings.tutorialCompletedText': never;
    'i18nStrings.learnMoreLinkText': never;
    'i18nStrings.startTutorialButtonText': never;
    'i18nStrings.restartTutorialButtonText': never;
    'i18nStrings.completionScreenTitle': never;
    'i18nStrings.feedbackLinkText': never;
    'i18nStrings.dismissTutorialButtonText': never;
    'i18nStrings.taskTitle': {
      taskNumber: string | number;
      taskTitle: string | number;
    };
    'i18nStrings.stepTitle': {
      stepNumber: string | number;
      stepTitle: string | number;
    };
    'i18nStrings.labelExitTutorial': never;
    'i18nStrings.labelTotalSteps': {
      totalStepCount: string | number;
    };
    'i18nStrings.labelsTaskStatus.pending': never;
    'i18nStrings.labelsTaskStatus.in-progress': never;
    'i18nStrings.labelsTaskStatus.success': never;
  };
  wizard: {
    'i18nStrings.stepNumberLabel': {
      stepNumber: string | number;
    };
    'i18nStrings.collapsedStepsLabel': {
      stepNumber: string | number;
      stepsCount: string | number;
    };
    'i18nStrings.skipToButtonLabel': {
      task__title: string | number;
    };
    'i18nStrings.navigationAriaLabel': never;
    'i18nStrings.cancelButton': never;
    'i18nStrings.previousButton': never;
    'i18nStrings.nextButton': never;
    'i18nStrings.optional': never;
    'i18nStrings.nextButtonLoadingAnnouncement': never;
    'i18nStrings.submitButtonLoadingAnnouncement': never;
  };
}
